import { Radio as MuiRadio, RadioProps as MuiRadioProps, SxProps, Theme } from '@mui/material';

type RadioBaseProps = Pick<MuiRadioProps, 'size' | 'checked' | 'disabled' | 'onChange' | 'onClick'>;

export interface RadioProps extends RadioBaseProps {
	checked?: boolean;
	size?: any;
	onChange?: any;
	disabled?: boolean;
	sx?: SxProps<Theme>;
}

const Radio = ({ checked, size, disabled, onChange, ...rest }: RadioProps) => (
	<MuiRadio size={size} checked={checked} disabled={disabled} onChange={onChange} {...rest} />
);

Radio.defaultProps = {
	size: 'medium',
	checked: false,
	onChange: () => {},
	disabled: false,
};
export default Radio;
